export default {
    namespaced: true,
    state: {
        orderIds: undefined,
        orders: {}
    },
    mutations: {
        orderIds(state, orderIds) {
            state.orderIds = orderIds
        }
    },
    actions: {
        async orderIds({state, dispatch, commit}) {
            if (state.orderIds === undefined) {
                commit('orderIds', [])
                
                const orderIds = (await dispatch('request/get', {
                    url: 'api/component/order_log/orderId',
                    params: {groupBy: 'orderId'}
                }, {root: true})).data.values
                
                commit('orderIds', orderIds)
            }
            
            return state.orderIds
        },
        async get({state, dispatch, commit}, orderId) {
            if (state.orders[orderId]) {
                return state.orders[orderId]
            } else {
                const logs = (await dispatch('request/get', {
                    url: 'api/component/order_log',
                    params: {
                        orderId,
                        sort: '-createdDate'
                    }
                }, {root: true})).data.items
                
                state.orders[orderId] = logs
                
                return logs
            }
        }
    },
}